import { DirectusImageProps } from '@/src/components/common/DirectusImage/DirectusImage.types'
import Img, { NoImg } from '@/src/components/common/Img/Img'

export default function DirectusImageClient(_: DirectusImageProps) {
  if (!_.directusFile) return <NoImg />

  const { directusFile, ...imgProps } = _
  return (
    <Img
      {...imgProps}
      src={`/.images/${directusFile.id}`}
      alt={imgProps.alt ?? directusFile?.title ?? ''}
      style={{
        aspectRatio:
          directusFile.width && directusFile.height
            ? `${directusFile.width}/${directusFile.height}`
            : undefined,
        ..._.style,
      }}
    />
  )
}
